/** Labels for fleet enums and capabilities (English source strings; translate with t()). */
import { msg, t } from '@/lib/i18n';
import type { SelectOption, Tone } from '@/ui';

export const VEHICLE_TYPES: Record<string, string> = {
  truck: msg('Truck'),
  van: msg('Van'),
  car: msg('Car'),
  bus: msg('Bus'),
  motorcycle: msg('Motorcycle'),
  trailer: msg('Trailer'),
  machine: msg('Machine'),
  other: msg('Other'),
};

export const FUEL_TYPES: Record<string, string> = {
  diesel: msg('Diesel'),
  petrol: msg('Petrol'),
  lng: msg('LNG'),
  cng: msg('CNG'),
  electric: msg('Electric'),
  hybrid: msg('Hybrid'),
  hydrogen: msg('Hydrogen'),
  none: msg('None'),
};

export const STATUS: Record<string, { label: string; tone: Tone }> = {
  active: { label: msg('Active'), tone: 'good' },
  inactive: { label: msg('Inactive'), tone: 'neutral' },
  retired: { label: msg('Retired'), tone: 'neutral' },
  stock: { label: msg('In stock'), tone: 'info' },
};

export const LANGUAGES: Record<string, string> = { en: 'English', nl: 'Nederlands', fr: 'Français', de: 'Deutsch' };

export const CAPABILITIES: Record<string, string> = {
  gps: msg('GPS'),
  ignition: msg('Ignition'),
  accelerometer: msg('Accelerometer'),
  can: msg('CAN bus'),
  can_pedals: msg('Pedals (CAN)'),
  cruise: msg('Cruise control'),
  pto: msg('PTO'),
  fuel: msg('Fuel'),
  harsh_events: msg('Harsh events'),
  adas_headway: msg('Headway (ADAS)'),
  adas_fcw: msg('Forward collision (ADAS)'),
  adas_pcw: msg('Pedestrian collision (ADAS)'),
  adas_ldw: msg('Lane departure (ADAS)'),
  dsm: msg('Driver monitoring'),
  tacho: msg('Tachograph'),
  driver_id: msg('Driver ID'),
  beacons: msg('Beacons'),
  video: msg('Video'),
  immobilizer: msg('Immobiliser'),
  temperature: msg('Temperature'),
  phone: msg('Phone'),
};

export const APPLIES_TO: Record<string, string> = { vehicle: msg('Vehicles'), driver: msg('Drivers'), asset: msg('Assets') };

/** Grouping modes (ADR-0005): how history is attributed to a group. */
export const GROUPING_MODES: Record<string, { label: string; help: string }> = {
  membership: { label: msg('Counted while members'), help: msg('History counts for the group only for the time a member belonged to it.') },
  current: { label: msg('Current members, full history'), help: msg("The group shows its current members' whole history.") },
};

export const label = (map: Record<string, string>, key: string | null | undefined): string => (key ? t(map[key] ?? key) : '—');

export const options = (map: Record<string, string>): SelectOption[] => Object.entries(map).map(([value, l]) => ({ value, label: t(l) }));

export const capabilityLabel = (key: string): string => t(CAPABILITIES[key] ?? key.replace(/_/g, ' '));

export const statusLabel = (key: string | null | undefined): string => (key ? t(STATUS[key]?.label ?? key) : '—');
